import { FactoryTypes } from "../models";
import { createStep } from "./StepFactory";
import { createDecisionStep } from "./DecisionStepFactory";
import { createGuideIntroduction } from "./GuideIntroductionFactory";
import { createTipBox } from "./TipBoxFactory";
import { createPopup } from "./PopupFactory";
import { createExpertHelp } from "./ExpertHelpFactory";
import { createImageCarousel } from "./ImageCarouselFactory";
import { createActivationForm } from "./ActivationFormFactory";
import { createWizardContainer } from "./WizardContainerFactory";
import { createWizardStepLink } from "./WizardStepLinkFactory";
import { createImage } from "./ImageFactory";
import { createWizardButton } from "./WizardButtonFactory";

export const getFactoryByType = (
  factoryType: FactoryTypes,
): CallableFunction => {
  const mapping = {
    [FactoryTypes.STEP]: createStep,
    [FactoryTypes.NUMBERED_STEP]: createStep,
    [FactoryTypes.DECISION_STEP]: createDecisionStep,
    [FactoryTypes.GUIDE_INTRO]: createGuideIntroduction,
    [FactoryTypes.TIPBOX]: createTipBox,
    [FactoryTypes.POPUP]: createPopup,
    [FactoryTypes.EXPERT_HELP]: createExpertHelp,
    [FactoryTypes.IMAGE]: createImage,
    [FactoryTypes.IMAGE_CAROUSEL]: createImageCarousel,
    [FactoryTypes.ACTIVATION_FORM]: createActivationForm,
    [FactoryTypes.WIZARD]: createWizardContainer,
    [FactoryTypes.SUB_STEP]: createStep,
    [FactoryTypes.DROPDOWN_STEP]: createStep,
    [FactoryTypes.WIZARD_STEP_LINK]: createWizardStepLink,
    [FactoryTypes.SURVEY_STEP]: () => ({}),
    [FactoryTypes.WIZARD_BUTTON]: createWizardButton,
  };
  return mapping[factoryType];
};
